import type { ReactNode } from "react"

import MobileStoreShell from "./MobileStoreShell"

const MobileStoreFrame = ({ children }: { children: ReactNode }) => {
  return (
    <>
      <MobileStoreShell />
      <div className="mobile-store-content">{children}</div>
    </>
  )
}

export default MobileStoreFrame
